import { Injectable } from '@angular/core';
import { DbModel } from '@app/databases/models/db.model';
import { DbMigrationStatus } from '@app/databases/enums/db-migration-status.enum';
import { IconDefinition, faCloudCheck, faCloudArrowUp, faCloudXmark } from '@fortawesome/pro-solid-svg-icons';
/* eslint-disable @typescript-eslint/naming-convention */
@Injectable({
    providedIn: 'root'
})
export class GcsMigrationService {

    private normalize(s: string): string {
        return s.trim();
    }

    private isDbMigrationStatus(s: string): s is DbMigrationStatus {
        return (Object.values(DbMigrationStatus) as string[]).includes(s);
    }

    private readonly icon_by_status: Record<DbMigrationStatus, IconDefinition> = {
        // Successful
        [DbMigrationStatus.Successful]:      faCloudCheck,
        [DbMigrationStatus.Migrated]:        faCloudCheck,
        // Pending
        [DbMigrationStatus.Pending]:         faCloudArrowUp,
        [DbMigrationStatus.Ready]:           faCloudArrowUp,
        [DbMigrationStatus.Checked]:         faCloudArrowUp,
        // Failed
        [DbMigrationStatus.PreflightFailed]: faCloudXmark,
        [DbMigrationStatus.Skipped]:         faCloudXmark,
        [DbMigrationStatus.DiffChecking]:    faCloudXmark,
        [DbMigrationStatus.DiffFound]:       faCloudXmark,
        [DbMigrationStatus.DiffCheckFailed]: faCloudXmark,
        [DbMigrationStatus.Reverted]:        faCloudXmark,
        [DbMigrationStatus.RevertRequested]: faCloudXmark
    };

    public getDbMigrationStatusIcon(database: DbModel): IconDefinition | undefined {
        const raw = this.normalize(database.migration_status);
        if (!this.isDbMigrationStatus(raw)) return undefined; // unknown status
        return this.icon_by_status[raw];
    }

    public getDbMigrationStatusMessage(database: DbModel): string {
        return 'GCP Migration Status: ' + (database.migration_status ?? '');
    }
}
